import { Component, Input,OnInit } from '@angular/core';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
    @Input() size: number = 25;
    @Input() show: boolean;
}


// WEBPACK FOOTER //
// ./src/app/spinner/spinner.component.ts